<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">{{mode}} Reimbursements</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">

                <!-- Request for Employee -->
                <v-layout v-if="isRequestForOtherUser" row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="requestForUserId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Request for Employee"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>

                <!-- Amount -->
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-row"> 
                        <v-text-field label="Amount" 
                            v-model="amount" 
                            :disabled="disabled"
                            :rules="[rules.required_numeric,rules.max_number]"
                            type="number" min="1" step="1" value="0.00" max="100"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>

                <!-- Type -->
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-row"> 
                        <v-select
                            label="Type"
                            :items="reimbursement_types"
                            :rules="[rules.required]" 
                            item-text="reimbursementType"
                            item-value="reimbursementTypeId"
                            :disabled="disabled"
                            :loading="loading_types"
                            v-model="reimbursementTypeId"
                        ></v-select>
                    </v-flex>
                </v-layout>

                <!-- Remarks -->
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-row"> 
                        <v-textarea v-model="description" label="Remarks" rows="2" color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
                
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading">{{mode}}</v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled">Clear</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import reimbursementApi from '@/api/reimbursements'
import employeeApi from '@/api/employees'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'

export default {
    data () {
        return {
            loading: false,
            loading_employees: false,
            loading_types: false,
            disabled: false,
            error: false,
            errorMessage: null,

            //put in rules-helper.js
            rules: {
                required: value => !!value || 'Required field.',
                required_numeric: value => !!value || 'Required field. Numeric Only',
                max_number: value => value<=100000 || 'Invalid Amount. Maximum of 100,000.00'                   
            },

            mode: '',
            reimbursementsId: "0",
            amount: null,
            description: "",
            reimbursementTypeId: null,
            reimbursement_types: [],
            employees: [],
            isRequestForOtherUser: null,
            requestForUserId: null,
            pageKey: null
        }
    },
    methods: {
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        reimbursementsId: this.reimbursementsId,
                        isRequestForOtherUser: this.isRequestForOtherUser,
                        requestForUserId: this.requestForUserId,
                        amount: this.amount,
                        reimbursementTypeId: this.reimbursementTypeId,
                        description: this.description
                    }
                    var response = null
                    if (this.mode == 'Add')
                        response = await reimbursementApi.add(data, this.pageKey)
                    else
                        response = await reimbursementApi.update(data, this.pageKey)
                        
                    if (response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setAdd(data) {
            this.mode = 'Add'
            this.isRequestForOtherUser = data.isRequestForOtherUser
            this.pageKey = data.pageKey

            if (this.isRequestForOtherUser && this.employees.length==0) await this.getEmployees()
            if (this.reimbursement_types.length==0) await this.getTypes()
        },
        async setUpdate(data, pageKey) {
            this.mode = 'Update'
            this.pageKey = pageKey
            this.isRequestForOtherUser = data.isRequestForOtherUser

            if (this.reimbursement_types.length==0) await this.getTypes()

            this.reimbursementsId = data.reimbursementsId
            this.amount = data.amount
            this.reimbursementTypeId = data.reimbursementTypeId
            this.description = data.description
        },
        async getTypes() {
            try {
                this.disabled = true
                this.loading_types = true
                const response = await reimbursementApi.getTypes()
                if (response && response.status == 200) {
                    this.reimbursement_types = response.data.items
                }
                this.loading_types = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.reimbursements)
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            group: item.team
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        closeDialog() {
            this.clearForm()
            this.$emit('update:dialogAddEdit', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.remarks = ''
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 15px 0px 15px;
}
</style>